import React from 'react'
import { useState, useEffect, useContext } from "react"
import { useTranslation } from 'react-i18next'
import * as toastr from "toastr"
import Styled from 'styled-components'
import CardExercice from 'Placements/Components/CardExercice/CardExercice'

import API from "Placements/API"
import getConfig from "Placements/Utils/GetRequestConfig.util"
import Loader from "Placements/Components/Loader"
import Button, { Button2 } from 'Placements/Components/Button'
import UserContext from "Placements/User.context"
import ChooseMultiple from "Placements/Template/ChooseMultiple.view"
import { ContainerFlex } from "Placements/Styles/Global.style";


const DivStyled = Styled.div`
    display: flex;
    margin: 1rem 0;
    justify-content: center;
`


const Test = () => {

    const [isLoading, setLoading] = useState(true)
    const [tela, setTela] = useState(null);
    const [sessao, setSessao] = useState(null);
    const [answers, setAnswers] = useState(new Map())
    const [info, setInfo] = useState<Info>(null)

    const { t, i18n } = useTranslation()
    const { usuario }: any = useContext(UserContext)

    useEffect(() => {
        setSessao(JSON.parse(localStorage.getItem("SessaoPl")))
    }, [])

    useEffect(() => {
        if (sessao) {
            API.Tela.Get({ idTesteParte: sessao.idTesteParte, ordem: sessao.ordemTela }, getConfig())
                .then((response: any) => {
                    setTela(response.data)
                }).catch((error: any) => {
                    toastr.error(error)
                })

            if (info == null) {
                API.Test.Last({ idUsuario: usuario.Id_Usuario }, getConfig())
                    .then((response: any) => {
                        setInfo(response.data)
                    }).catch((error: any) => {
                        toastr.error(error)
                    })
            }
        }
    }, [sessao])

    useEffect(() => {
        if (tela && tela.respostasUsuario) {
            const entry = new Map()
            tela.respostasUsuario.forEach((each: Alternativa) => {
                entry.set(each.Id_Exercicio, each.Id_Alternativa);
            })
            setAnswers(entry)
        }
        setLoading(false)
    }, [tela])

    useEffect(() => {
        if (info) {
            switch (info.placementId) {
                case 1: i18n.changeLanguage('en'); break;
                case 2: i18n.changeLanguage('es'); break;
                default: i18n.changeLanguage('en');
            }
        }
    }, [info])

    const save = async () => {

        const teste: Array<Alternativa> = []

        answers.forEach((value: number, key: number) => teste.push({ Id_Alternativa: value, Id_Exercicio: key, Id_Teste_Parte: sessao.idTesteParte }))

        return await API.Exercicio.Save({
            idUsuario: usuario.Id_Usuario,
            isNext: true,
            teste,
        }, getConfig())
            .then((response: any) => {
                return response.data
            })
    }

    const goToSection = async (next: boolean) => {
        setLoading(true)
        const lastOrder = JSON.parse(localStorage.getItem("SessaoPl")).ordemTela

        if (!(!next && sessao.ordemTela == lastOrder)) {
            try {
                const final = await save()

                if (final == "testeFinalizado") {
                    window.location.href = "#/test/final-report"
                    return
                } else if (final == "parteFinalizada") {
                    window.location.href = "#/test/partial-report"
                    return
                }
            } catch (error) {
                toastr.error(error)
                setLoading(false)
                return
            }
        }

        /* sesao anterior */
        if (!next) {
            setSessao({ ...sessao, ordemTela: sessao.ordemTela - 1 })
            window.scrollTo(0, 0);
        }
        /* proxima seção */
        else if (sessao.ordemTela + 1 < lastOrder) {
            setSessao({ ...sessao, ordemTela: sessao.ordemTela + 1 })
        }
        /* ultima seção */
        else {
            API.Sessao.Get({ idTesteUsuario: info.ultimoTesteUsuario }, getConfig())
                .then((resp: any) => {
                    localStorage.setItem("SessaoPl", JSON.stringify(resp.data))
                    setSessao(resp.data)
                    setAnswers(new Map())
                }).catch((error: any) => {
                    toastr.error('Não foi possível recuperar informações', '');
                    window.location.href = "#/login"
                })
        }
    }

    const adapteExercice = (exercise: Exercise) => {
        /*
         option.id_resposta
         option.ordem
         option.resposta
         */
        /*
        exercise.respostas_Exercicio_Yconnect
        exercise.midia_Yconnect[0]
        exercise.midia_Yconnect[0].url
        exercise.ajuda
        exercise.texto
        exercise.conteudo_exercicio
        */
        const exercice = {
            respostas_Exercicio_Yconnect: exercise.Alternativas == null ? [] : exercise.Alternativas.map((each: Alternativa) => {
                return {
                    id_resposta: each.Id_Exercicio,
                    ordem: each.Id_Alternativa,
                    resposta: each.Descricao,
                }
            }),
            midia_Yconnect: [
                exercise.Audio ? { tipo_midia: 'audio', url: exercise.Audio } : null,
                exercise.Imagem ? { tipo_midia: 'image', url: exercise.Imagem } : null
            ],
            conteudo_exercicio: exercise.Subenunciado,
            ajuda: exercise.Enunciado,
            texto: exercise.Texto,
            //?:exercise.Traducao
        }
        return exercice
    }

    const handleChange = (id: number, value: any) => {
        const entry = new Map(answers)
        entry.set(id, value.resposta);
        setAnswers(entry)
    }

    if (isLoading || tela == null) return <Loader />

    return (
        <ContainerFlex className="py-4">
            {tela.tela.Enunciado ?
                <CardExercice
                    className="text-center p-5"
                    testName={sessao.parte.Nome}
                    question={`${
                        t('question-breadcrumb-plural', { telaExercicioOrdem: tela.tela.Exercicios[0].Ordem })
                        } ${tela.tela.Exercicios[tela.tela.Exercicios.length - 1].Ordem}`}
                    tooltip={tela.tela.Traducao}
                >
                    <ChooseMultiple
                        exercise={adapteExercice(tela.tela)}
                    ></ChooseMultiple>
                </CardExercice>

                : null}
            {tela.tela.Exercicios.map((each: Exercise, idx: number) =>
                <CardExercice
                    className="text-center p-5"
                    key={idx}
                    testName={sessao.parte.Nome}
                    question={`${t('question-exerc-breadcrumb')} ${each.Ordem}`}
                    tooltip={each.Traducao}
                >
                    <ChooseMultiple
                        id={each.Id_Exercicio}
                        answer={answers.get(each.Id_Exercicio)}
                        exercise={adapteExercice(each)}
                        onChange={(id: number, value: any) => handleChange(id, value)}
                    />
                </CardExercice>
            )
            }
            <DivStyled>
                {sessao.ordemTela > 1 &&
                    <Button2
                        className="form-btn btn button-section"
                        onClick={() => { goToSection(false) }}
                    >
                        <em className="icon icon-previous" />
                        <span>{t('previous-button')}</span>
                    </Button2>
                }

                {!tela.ehUltimaTelaParte ? <Button2
                    className="form-btn btn button-section"
                    onClick={() => { goToSection(true) }}
                    disabled={answers.size < tela.tela.Exercicios.length}
                >
                    <span>{t('next-button')}</span>
                    <em className="icon icon-next" />
                </Button2>
                    :
                    <Button
                        className="form-btn btn button-section"
                        onClick={() => { goToSection(true) }}
                        disabled={answers.size < tela.tela.Exercicios.length}
                    >
                        <span>{t('submit-button')}</span>
                    </Button>}
            </DivStyled>
        </ContainerFlex>
    )
}

export default Test